<template>
  <section class="px-5 xl:px-8 grid xl:grid-cols-12 gap-12 mt-16 pt-2 tt-bg-light">
    <div class="flex items-center justify-center xl:col-start-1 xl:col-span-6">
      <picture>
        <source srcset="../../assets/iphones.webp" type="image/webp">
        <source srcset="../../assets/iphones.png" type="image/png">
        <img src="../../assets/iphones.png" alt="How does it work?"
             class="object-cover pointer-events-none select-none w-full">
      </picture>
    </div>
    <div class="flex items-start justify-center flex-col xl:col-end-12 xl:col-span-5">
      <h2 class="tt-text-black font-extrabold text-3xl xl:text-5xl self-start place-content-start">
        {{ $t('hwitorsk') }}
      </h2>
      <p class="mt-6">
        {{ $t('hwitorsk2') }}
      </p>

      <div class="flex items-center justify-start gap-8 border-b tt-border-lightgray w-full mt-6">
        <button class="font-semibold tt-text-green border-b-2 transform translate-y-px tt-border-green"
                id="forCreators" @click="howitworks(1)">
          {{ $t('forrerrat') }}
        </button>

        <button class="font-semibold tt-text-black transform translate-y-px" id="forTourists" @click="howitworks(2)">
          {{ $t('fortutriesu') }}
        </button>
      </div>

      <div class="flex items-start justify-start flex-col gap-8 mt-8" v-if="this.howItWorksState===1">
        <div class="flex items-center justify-start place-content-start gap-4">
          <div class="flex-none rounded-full h-16 w-16 flex items-center justify-center bg-white tt-text-black shadow-md">
            <DownloadIcon />
          </div>
          <div>
            <h4 class="font-semibold">
              {{ $t('choosetra') }}
            </h4>
            <p class="mt-2">
              {{ $t('choosetra1') }}
            </p>
          </div>
        </div>

        <div class="flex items-center justify-start place-content-start gap-4">
          <div class="flex-none rounded-full h-16 w-16 flex items-center justify-center bg-white tt-text-black shadow-md">
            <EmojiHappyIcon />
          </div>
          <div>
            <h4 class="font-semibold">
              {{ $t('choosetra2') }}
            </h4>
            <p class="mt-2">
              {{ $t('choosetra3') }}
            </p>
          </div>
        </div>

        <div class="flex items-center justify-start place-content-start gap-4">
          <div class="flex-none rounded-full h-16 w-16 flex items-center justify-center bg-white tt-text-black shadow-md">
            <DeviceMobileIcon />
          </div>
          <div>
            <h4 class="font-semibold">
              {{ $t('choosetra4') }}
            </h4>
            <p class="mt-2">
              {{ $t('choosetra5') }}
            </p>
          </div>
        </div>
      </div>
      <div class="flex items-start justify-start flex-col gap-8 mt-8" v-if="this.howItWorksState===2">
        <div class="flex items-center justify-start place-content-start gap-4">
          <div class="flex-none rounded-full h-16 w-16 flex items-center justify-center bg-white tt-text-black shadow-md">
            <DownloadIcon />
          </div>
          <div>
            <h4 class="font-semibold">
              {{ $t('choosetra6') }}
            </h4>
            <p class="mt-2">
              {{ $t('choosetra7') }}
            </p>
          </div>
        </div>

        <div class="flex items-center justify-start place-content-start gap-4">
          <div class="flex-none rounded-full h-16 w-16 flex items-center justify-center bg-white tt-text-black shadow-md">
            <EmojiHappyIcon />
          </div>
          <div>
            <h4 class="font-semibold">
              {{ $t('choosetra8') }}
            </h4>
            <p class="mt-2">
              {{ $t('choosetra9') }}
            </p>
          </div>
        </div>

        <div class="flex items-center justify-start place-content-start gap-4">
          <div class="flex-none rounded-full h-16 w-16 flex items-center justify-center bg-white tt-text-black shadow-md">
            <DeviceMobileIcon />
          </div>
          <div>
            <h4 class="font-semibold">
              {{ $t('choosetra10') }}
            </h4>
            <p class="mt-2">
              {{ $t('choosetra11') }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {DownloadIcon, EmojiHappyIcon, DeviceMobileIcon} from "@vue-hero-icons/outline";


export default {
  name: "HowItWorks",
  components: {
    DownloadIcon, EmojiHappyIcon, DeviceMobileIcon,
  },
  data() {
    return {
        howItWorksState: 1,
    }
  },
  methods: {
    howitworks: function (number) {
      this.howItWorksState = number

      if(number===1) {
        document.getElementById("forCreators").classList.add("tt-text-green")
        document.getElementById("forCreators").classList.add("tt-border-green")
        document.getElementById("forCreators").classList.add("border-b-2")
        document.getElementById("forCreators").classList.remove("tt-text-black")

        document.getElementById("forTourists").classList.remove("tt-text-green")
        document.getElementById("forTourists").classList.remove("tt-border-green")
        document.getElementById("forTourists").classList.remove("border-b-2")
        document.getElementById("forTourists").classList.add("tt-text-black")
      }
      else if(number===2) {
        document.getElementById("forTourists").classList.add("tt-text-green")
        document.getElementById("forTourists").classList.add("tt-border-green")
        document.getElementById("forTourists").classList.add("border-b-2")
        document.getElementById("forTourists").classList.remove("tt-text-black")

        document.getElementById("forCreators").classList.remove("tt-text-green")
        document.getElementById("forCreators").classList.remove("tt-border-green")
        document.getElementById("forCreators").classList.remove("border-b-2")
        document.getElementById("forCreators").classList.add("tt-text-black")
      }
    }
  }
}
</script>